import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Select } from 'antd'

const FilterAdmissionStudent = ({
  filterValue,
  setFilterValue,
  setCurrentPage
}) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [tempfilterValue, setTempFilterValue] = useState({})
  const [categoryFilter, setCategoryFilter] = useState([])
  const [collegeFilter, setCollegeFilter] = useState([])
  const [majorFilter, setMajorFilter] = useState([])
  const [durationFilter, setDurationFilter] = useState([])

  useEffect(() => {
    callStudentFilter()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid])

  const callStudentFilter = (college) => { 
    axios.post('/p/admission_notice/student/filter/get', { 
      merchant_oid: merchantOid,
      college: college
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setCollegeFilter(response.data.colleges)
          setMajorFilter(response.data.majors)
          setDurationFilter(response.data.durations)
          setCategoryFilter(response.data.categories)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  let categoryItems = [
    {  
      value: '', 
      label: '全部'
    },
    ...categoryFilter.map((item) => (
      {
        value: item,
        label: item
      }
    ))
  ]

  let collegeItems = [
    {  
      value: '', 
      label: '全部'
    },
    ...collegeFilter.map((item) => (
      {
        value: item,
        label: item
      }
    ))
  ]

  let majorItems = [
    {  
      value: '', 
      label: '全部'
    },
    ...majorFilter.map((item) => (
      {
        value: item,
        label: item
      }
    ))
  ]

  let durationItems = [
    {  
      value: '', 
      label: '全部'
    },
    ...durationFilter.map((item) => (
      {
        value: item,
        label: item
      }
    ))
  ]

  let isPrintItems = [
    {  
      value: 2, 
      label: '全部'
    },
    {
      value: 0,
      label: '未打印'
    },
    {
      value: 1,
      label: '已打印'
    }
  ]

  const clickCategoryFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, category: value })
  }

  const clickCollageFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, college: value, major: '' })
    callStudentFilter(value)
  }

  const clickMajorFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, major: value })
  }

  const clickDurationFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, duration: value })
  }

  const clickIsPrintFilter = (value) => {
    setTempFilterValue({ ...tempfilterValue, is_print: value })
  }

  const clickSubmitFilter = () => {
    setFilterValue({ ...filterValue, ...tempfilterValue })
    setCurrentPage(1)
  }

  const clickResetFilter = () => {
    setFilterValue({ ...filterValue, category: '', college: '', major: '', duration: '', is_print: 2 })
    callStudentFilter()
    setTempFilterValue({})
  }

  return (
    <div className='public-conditions'>
      <div className='public-conditions-row'>
        <div className='public-condition'>
          <div className='public-condition-label'>选择学院：</div>
          <Select
            value={tempfilterValue.college}
            placeholder="请选择"
            options={collegeItems}
            style={{width: '220px'}}
            onChange={(value) => clickCollageFilter(value)}
          />
        </div>

        <div className='public-condition'>
          <div className='public-condition-label'>选择专业：</div>
          <Select
            value={tempfilterValue.major}
            placeholder="请选择"
            options={majorItems}
            style={{width: '220px'}}
            onChange={(value) => clickMajorFilter(value)}
          />
        </div>

        <div className='public-condition'>
          <div className='public-condition-label'>打印状态：</div>
          <Select
            value={tempfilterValue.is_print} 
            placeholder="请选择"
            options={isPrintItems}
            style={{width: '220px'}}
            onChange={(value) => clickIsPrintFilter(value)}
          />
        </div>
      </div>

      <div className='public-conditions-row'>
        <div className='public-condition'>
          <div className='public-condition-label'>选择学制：</div>
          <Select
            value={tempfilterValue.duration} 
            placeholder="请选择"
            options={durationItems}
            style={{width: '220px'}}
            onChange={(value) => clickDurationFilter(value)}
          />
        </div>

        <div className='public-condition'>
          <div className='public-condition-label'>选择类型：</div>
          <Select
            value={tempfilterValue.category}
            placeholder="请选择"
            options={categoryItems}
            style={{width: '220px'}}
            onChange={(value) => clickCategoryFilter(value)}
          />
        </div>
      </div>

      <div className='public-conditions-buttons'>
        <div className='public-conditions-button1' onClick={() => { clickSubmitFilter() }}>筛选</div>
        <div className='public-conditions-button2' onClick={() => { clickResetFilter() }}>重置</div>
      </div>
    </div>
  )
}

export default FilterAdmissionStudent
